import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'

import MyImage from '@shared/components/myImage'
import TeamImage from '@assets/images/placeholder/team-placeholder.svg'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import { useRouter } from 'next/router'

const HeadToHead = ({ data, matchDetail }) => {
  const router = useRouter()
  const teamAWinMatches = data?.filter((match) => match?.oWinner?._id === matchDetail?.oTeamScoreA?.oTeam?._id)
  const teamBWinMatches = data?.filter((match) => match?.oWinner?._id === matchDetail?.oTeamScoreB?.oTeam?._id)

  const handleClick = (slug) => {
    if (slug) {
      router.push(`/${slug}`)
    }
  }

  return (
    <section className="mb-1 mb-md-2 content-visibility-auto">
      <h6>{'Head to Head'}</h6>
      <div className={`${styles.headToHead} overflow-hidden mt-0`}>
        <div className={`${styles.item} ${styles.head} d-flex align-items-center px-2 px-md-3`}>
          <div className={`${styles.teamName} d-flex align-items-center`}>
            <div className={`${styles.teamImg} me-2 overflow-hidden flex-shrink-0`}>
              <MyImage placeholderImage={TeamImage} src={matchDetail?.oTeamScoreA?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${matchDetail?.oTeamScoreA?.oTeam?.oImg?.sUrl}` : TeamImage} layout="responsive" width="20" height="20" alt={matchDetail?.oTeamScoreA?.oTeam?.sAbbr} autoRadiusImage/>
            </div>
            <p className="d-none d-sm-block mb-0">{matchDetail?.oTeamScoreA?.oTeam?.sTitle || matchDetail?.oTeamScoreA?.oTeam?.sAbbr}</p>
            <p className="d-sm-none mb-0">{matchDetail?.oTeamScoreA?.oTeam?.sAbbr || matchDetail?.oTeamScoreA?.oTeam?.sTitle}</p>
          </div>
          <p className={`${styles.score} text-center font-ebold mb-0`}>{`${teamAWinMatches?.length || 0} - ${teamBWinMatches?.length || 0}`}</p>
          <div className={`${styles.teamName} d-flex align-items-center justify-content-end text-end`}>
            <p className="d-none d-sm-block mb-0">{matchDetail?.oTeamScoreB?.oTeam?.sTitle || matchDetail?.oTeamScoreB?.oTeam?.sAbbr}</p>
            <p className="d-sm-none mb-0">{matchDetail?.oTeamScoreB?.oTeam?.sAbbr || matchDetail?.oTeamScoreB?.oTeam?.sTitle}</p>
            <div className={`${styles.teamImg} ms-2 overflow-hidden flex-shrink-0`}>
              <MyImage placeholderImage={TeamImage} src={matchDetail?.oTeamScoreB?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${matchDetail?.oTeamScoreB?.oTeam?.oImg?.sUrl}` : TeamImage} layout="responsive" width="20" height="20" alt={matchDetail?.oTeamScoreB?.oTeam?.sAbbr} autoRadiusImage/>
            </div>
          </div>
        </div>
        {
          data?.map((match, index) => {
            const is100 = match?.oFormat?.sValue?.includes('t100')
            return (
              <div key={index} className={`${styles.item} d-flex align-items-center mx-3`} onClick={() => handleClick(match?.oSeo?.sSlug)}>
                <div className={`${styles.team} me-1`}>
                  <p className="mb-0">{match?.oTeamScoreA?.oTeam?.sAbbr || match?.oTeamScoreA?.oTeam?.sTitle}</p>
                  <p className="mb-0 me-md-0">
                    <span className="mb-0 font-bold">{`${match?.oTeamScoreA?.sScores} `}</span>
                    {`(${match?.oTeamScoreA?.sOvers} ${is100 ? 'b' : 'ov'})`}
                  </p>
                </div>
                <p className={`${styles.result} text-muted flex-grow-1 text-center mb-0`}>{match?.sResult || match?.sStatusNote}</p>
                <div className={`${styles.team} ms-1 text-end`}>
                  <p className="mb-0 ms-1">{match?.oTeamScoreB?.oTeam?.sAbbr || match?.oTeamScoreB?.oTeam?.sTitle}</p>
                  <p className="mb-0 me-md-0">
                    <span className="mb-0 font-bold">{`${match?.oTeamScoreB?.sScores} `}</span>
                    {`(${match?.oTeamScoreB?.sOvers} ${is100 ? 'b' : 'ov'})`}
                  </p>
                </div>
              </div>
            )
          })
        }
      </div>
    </section>
  )
}

HeadToHead.propTypes = {
  data: PropTypes.object,
  matchDetail: PropTypes.object,
  is100: PropTypes.bool
}

export default HeadToHead
